import { Name } from "./Name";
import { Price } from "./Price";
import { Input } from "./Input";
import { Header } from "./Header";
import { Rating } from "./Rating";
import { Footer } from "./Footer";
import { Button } from "./Button";
import { Loader } from "./Loader";
import { Switch } from "./Switch";
import { RatingStars } from "./RatingStars";
import { BlockHeading } from "./BlockHeading";
import { BottomSheet } from "./BottomSheet";
import SiteCard from "./SiteCard";
import { Toast } from "./Toast";

export const components = {
  Name,
  Header,
  Button,
  Input,
  Footer,
  Price,
  Loader,
  Rating,
  Switch,
  RatingStars,
  BlockHeading,
  BottomSheet,
  SiteCard,
  Toast
};
